import { BaseError } from './base.js';
export class SDKReferenceError extends BaseError {
    name = 'SDKReferenceError';
    constructor(key, details) {
        super(`${key} is not defined`, {
            details,
        });
    }
}
export class SDKRangeError extends BaseError {
    name = 'SDKRangeError';
    constructor(key, options) {
        const { details, min, max, enums } = options || {};
        const hasRange = typeof min !== 'undefined' ||
            typeof max !== 'undefined' ||
            typeof enums !== 'undefined';
        super(`${key} is out of range`, {
            details,
            metaMessages: hasRange
                ? [
                    'Valid range:',
                    typeof min !== 'undefined' && `min: ${min}`,
                    typeof max !== 'undefined' && `max: ${max}`,
                    enums && `enums: ${enums.join(', ')}`,
                ].filter(Boolean)
                : undefined,
        });
    }
}
//# sourceMappingURL=primitives.js.map